export default [
    {
      path: "/itemcategories",
      name: "itemcategories",
      component: () => import("@/views/category/CategoryView.vue"),
      meta: {
        pageTitle: 'Category List',
        breadcrumb: [
          {
              text: 'Category List',
              active: true,
          },
      ],
        permission: 'Permissions.Inventory.View'
      },
    },
    {
      path: "/itemcategories/:id",
      name: "category-details",
      component: () => import("@/views/category/CategoryDetailsView.vue"),
      meta: {
        pageTitle: 'Category Details',
        breadcrumb: [
          {
              text: 'Category List',
              to: '/itemcategories',
          },
          {
              text: 'Category Details',
              active: true,
          },
      ],
        permission: 'Permissions.Inventory.View'
      },
      props: true, // to pass the category id as a prop
    }
  ];
  